import(/* webpackMode: "eager" */ "/app/src/app/(lobby)/error.tsx");
